import { faSignIn } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import splash from '../../media/classroomSplash.jpg'
import QuoteIcon from '../../media/icon-science.svg?react'
import oftmcssLogo from '../../media/maricopa-footer-logo.svg'
import { Brand, Content, Templates } from 'ui'
import { InitialSignUp, Signup } from './Forms/InitialSignUp'
import { ConfirmAccount } from './Forms/ConfirmAccount'
import { randomTestimonial } from './testimonials'

/**
 * The initial step for creating an account as a teacher.
 */
export const InitialSignUpView: React.FC = () => {
  const [step, setStep] = useState(0)
  const [stepOneValues, setStepOneValues] = useState<Signup | null>(null)

  const testimonial = randomTestimonial()
  return (
    <Templates.SplashImageView
      backgroundImageSrc={splash}
      footerImageSrc={oftmcssLogo}
      splashContent={
        <Templates.SplashQuote
          quote={testimonial.quote}
          author={testimonial.author}
          title={testimonial.title}
          icon={
            <QuoteIcon
              style={{
                width: 'auto',
                height: '60px',
                display: 'block',
              }}
              className="fill-current text-white"
            />
          }
        />
      }
    >
      {step === 0 ? (
        <>
          <Helmet>
            <title>Start Connecting Today - MCSS PRO Connect</title>
          </Helmet>
          <Content.Region>
            <Brand.EpcLogo />
            <Content.Heading>Start Connecting Today</Content.Heading>
            <Content.Body>
              Educator PRO Connect supports teachers in Arizona, by connecting
              them with STEM and industry professionals to enhance real-world
              classroom applications and bring awareness to college and career
              pathways.
            </Content.Body>
            <InitialSignUp
              onSubmit={(values: Signup) => {
                setStepOneValues(values)
                setStep(1)
              }}
            />
            <Content.List>
              <Content.ListItem>
                <Content.ListIcon>
                  <FontAwesomeIcon icon={faSignIn} />
                </Content.ListIcon>
                <Content.Body>
                  Already have an account?{' '}
                  <Link to="/login" className="underline text-actionable">
                    Log in.
                  </Link>
                </Content.Body>
              </Content.ListItem>
            </Content.List>
          </Content.Region>
        </>
      ) : (
        <></>
      )}

      {step === 1 && stepOneValues ? (
        <>
          <Content.Region>
            <Brand.EpcLogo />
            <Content.Heading>Confirm Your Account</Content.Heading>
            <Content.Body>
              Before we get started building your profile, let's confirm your
              account and setup a memorable password.
            </Content.Body>
            <ConfirmAccount
              defaultValues={{
                emailAddress: stepOneValues?.emailAddress as string,
                password: '',
                passwordConfirm: '',
                passwordHint: '',
              }}
              profileValues={stepOneValues}
            />
          </Content.Region>
        </>
      ) : (
        <></>
      )}
    </Templates.SplashImageView>
  )
}
